import { ReactNode } from "react";
import { AuthStateProvider, useAuthState } from "./useAuthState";
import { AuthMethodsProvider, useAuthMethods } from "./useAuthMethods";

/**
 * @description Combined auth provider that wraps children with both AuthStateProvider and AuthMethodsProvider.
 * @param {{ children: ReactNode }} props - React children to wrap.
 */
export const AuthProvider = ({ children }: { children: ReactNode }) => {
  return (
    <AuthStateProvider>
      <AuthMethodsProvider>
        {children}
      </AuthMethodsProvider>
    </AuthStateProvider>
  );
};

/**
 * @description Combined auth hook that merges auth state (user, session, profile, roles) and auth methods (signIn, signUp, signOut).
 * @returns {object} Merged object containing all properties from useAuthState and useAuthMethods.
 */
export const useAuth = () => {
  const authState = useAuthState();
  const authMethods = useAuthMethods();

  return {
    ...authState,
    ...authMethods
  };
};
